import { render, staticRenderFns } from "./lookimage.vue?vue&type=template&id=3672d533&scoped=true"
import script from "./lookimage.vue?vue&type=script&lang=js"
export * from "./lookimage.vue?vue&type=script&lang=js"
import style0 from "./lookimage.vue?vue&type=style&index=0&id=3672d533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672d533",
  null
  
)

export default component.exports